<template>
  <v-tooltip location="top" open-delay="500">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        variant="tonal"
        :active="sidePanelTab === 'chatLog' && showSidePanel"
        @click="openAiAssistant"
      >
        Assistant
        <v-icon class="ml-1">mdi-creation</v-icon>
      </v-btn>
    </template>
    <span>AI Assistant (BETA)</span>
  </v-tooltip>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'

const store = useStore()

const sidePanelTab = computed(() => store.state.sidePanelTab)
const showSidePanel = computed(() => store.state.showSidePanel)

const openAiAssistant = () => {
  store.commit('setSidePanelTab', 'chatLog')
  store.commit('showSidePanel', true)
}

</script>
